module.exports = __webpack_public_path__ + "static/online_shopping.68fecf3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/online_shopping.png
// module id = 712
// module chunks = 154382131621592